// Ürün sıralama / arama yardımcıları (backend'deki sortItems.js ile aynı mantık)

export const typeLabels = {
  book: "Kitap",
  magazine: "Dergi",
  childrenMagazine: "Çocuk Dergisi",
};

const typeOrder = {
  book: 0,
  magazine: 1,
  childrenMagazine: 2,
};

const collator = new Intl.Collator("tr", { numeric: true, sensitivity: "base" });

export const normalizeName = (name) =>
  String(name || "").replace(/\s+/g, " ").trim();

// Tür → (dergilerde sayı no) → isim
export const compareItemsByGroup = (a, b) => {
  const typeDiff = (typeOrder[a?.type] ?? 99) - (typeOrder[b?.type] ?? 99);
  if (typeDiff !== 0) return typeDiff;

  if (a?.type !== "book") {
    const issueDiff = (a?.issueNumber ?? Infinity) - (b?.issueNumber ?? Infinity);
    if (issueDiff !== 0 && !Number.isNaN(issueDiff)) return issueDiff;
  }

  return collator.compare(normalizeName(a?.name), normalizeName(b?.name));
};

export const sortItemsByGroup = (itemList) =>
  [...itemList].sort(compareItemsByGroup);

export const sortByName = (list) =>
  [...list].sort((a, b) =>
    collator.compare(normalizeName(a?.name), normalizeName(b?.name))
  );

// Türkçe büyük/küçük harf duyarsız arama ("İslam" ~ "islam", "Işık" ~ "ışık")
export const matchesSearch = (text, term) =>
  normalizeName(text)
    .toLocaleLowerCase("tr")
    .includes(normalizeName(term).toLocaleLowerCase("tr"));
